import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BasicLayout from 'layouts/basic/basic.layout';
import SignIn from 'pages/sign-in/sign-in.page';
import LicensesPage from 'pages/licenses/licenses.page';

export default function RoutesIndex() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/" element={<BasicLayout />}>
        <Route index element={<Navigate to="/licenses" replace />} />
        <Route path="/licenses" element={<LicensesPage />} />
      </Route>
    </Routes>
  );
}
